import type {Coin} from './character-state';

export const COIN_ORDER: Coin[] = ['pp', 'gp', 'ep', 'sp', 'cp'];

export const COIN_TITLES: Record<Coin, string> = {
	pp: 'Платиновые',
	gp: 'Золотые',
	ep: 'Электрумовые',
	sp: 'Серебряные',
	cp: 'Медные',
};

export const COIN_SHORT_TITLES: Record<Coin, string> = {
	pp: 'ПМ',
	gp: 'ЗМ',
	ep: 'ЭМ',
	sp: 'СМ',
	cp: 'ММ',
};

const GOLD_VALUE: Record<Coin, number> = {
	pp: 10,
	gp: 1,
	ep: 0.5,
	sp: 0.1,
	cp: 0.01,
};

export const totalInGold = (coins: Record<Coin, number>) =>
	Math.round(COIN_ORDER.reduce((total, coin) => total + (coins[coin] || 0) * GOLD_VALUE[coin], 0) * 100) / 100;

export function changeCoins(
	coins: Record<Coin, number>,
	amounts: Partial<Record<Coin, number>>,
	sign: 1 | -1,
): Record<Coin, number> {
	return Object.fromEntries(
		COIN_ORDER.map((coin) => [coin, Math.max(0, (coins[coin] || 0) + sign * (amounts[coin] || 0))]),
	) as Record<Coin, number>;
}
